import { FormTracking } from "../types";
import { common } from "./common";

export const implementations: FormTracking.Implementations = {
  common
};
